import { saveFieldDetails } from '../../../actions/odooFieldActions';
import TextField from './TextField';
import { useEffect, useRef } from 'react';
import { useField, useForm } from 'react-final-form';
import { connect } from 'react-redux';

/**
 * A regular text field, but decorated with the Addressfinder widget.
 */
const AddressfinderField = ({ name, label, options, hasManyRow, parent, cssClass, helpText, disabled, required, apiKey, changeField }) => {
  const inputRef = useRef();
  const { input, meta } = useField(name);
  const form = useForm();

  useEffect(() => {
    const inputElement = inputRef.current;
    if (!window.AddressFinder || !inputElement) return;

    let widget = new window.AddressFinder.Widget(inputElement, apiKey, 'NZ', { show_locations: false });

    let targets = {};
    if (options?.target) {
      targets = {
        line1: options.target.line1,
        line2: options.target.line2,
        line3: options.target.line3,
        line4: options.target.line4,
        suburb: options.target.suburb,
        city: options.target.city,
        postcode: options.target.postcode,
        country: options.target.country,
      };
    }

    widget.on('result:select', function (fullAddress, metaData) {
      const selected = new window.AddressFinder.NZSelectedAddress(fullAddress, metaData);

      if (targets.line1) {
        changeField(targets.line1, selected.address_line_1(), hasManyRow, parent);
        form.change(targets.line1, selected.address_line_1());
      }
      if (targets.line2) {
        changeField(targets.line2, selected.address_line_2(), hasManyRow, parent);
        form.change(targets.line2, selected.address_line_2());
      }
      if (targets.line3) {
        changeField(targets.line3, '', hasManyRow, parent);
        form.change(targets.line3, '');
      }
      if (targets.line4) {
        changeField(targets.line4, '', hasManyRow, parent);
        form.change(targets.line4, '');
      }
      if (targets.suburb) {
        changeField(targets.suburb, selected.suburb(), hasManyRow, parent);
        form.change(targets.suburb, selected.suburb());
      }
      if (targets.city) {
        changeField(targets.city, selected.city(), hasManyRow, parent);
        form.change(targets.city, selected.city());
      }
      if (targets.postcode) {
        changeField(targets.postcode, selected.postcode(), hasManyRow, parent);
        form.change(targets.postcode, selected.postcode());
      }
      if (targets.country) {
        changeField(targets.country, 'NZ', hasManyRow, parent);
        form.change(targets.country, 'NZ');
      }
    });

    return () => {
      // Widget doesn't provide a destroy method, just null it out
      widget = null;
    };
  }, [apiKey, changeField, form, hasManyRow, options, parent]);

  return (
    <TextField
      input={{ ...input, ref: inputRef }}
      meta={meta}
      label={label}
      cssClass={cssClass}
      helpText={helpText}
      disabled={disabled}
      labelRequired={required}
    />
  );
};

const mapStateToProps = (state) => ({
  apiKey: state.config.addressfinder.key,
});

const mapDispatchToProps = (dispatch) => ({
  changeField(field, value, hasManyRow, parent) {
    dispatch(saveFieldDetails(field, parent?.name, hasManyRow, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressfinderField);
